import { FacetInputSubState, FacetState } from "@globalgiving/vast-frontend-common"
import { FacetInactiveSubstate } from "~/types/facet.ts"

export type EntityFacetField = {
  id: number
  entity_id: number
  facet_id: number
  name: string
  field_value: any
  field_value_changed_at: string
  approved_published_value: string
  approved_published_value_changed_at: string
  is_deleted: boolean
  created_by_uauser_uauserid: number
  created_at: string
  modified_by_uauser_uauserid: number
  last_modified_at: string
}

export type EntityFacetDetails = {
  id: number
  entity_id: number
  facet_id: number
  state: FacetState
  state_set_at: string
  publish_state: string
  publish_state_set_at: string
  is_validated: boolean
  stale_at: string
  expire_at: string
  inactive_substate: FacetInactiveSubstate
  input_substate: FacetInputSubState
  input_ready_to_submit_substate: string
  approved_substate: string
  pending_review_substate: string
  active_reviewer_uauser_uauserid: number
  is_deleted: boolean
  created_by_uauser_uauserid: number
  created_at: string
  modified_by_uauser_uauserid: number
  last_modified_at: string
}

export type EntityFacetInfo = {
  details: EntityFacetDetails
  fields: Record<string, EntityFacetField>
}

export const TYPE_FACET_NAME = "type"
export const IDENTITY_FACET_NAME = "identity"

/* Names of the specific facets that collect banking details. */
export const BANKING_DETAILS_FACET_NAMES = ["disbursementSelection", "ach", "check", "wire", "fxecute"]
